import CreateBonusPage from './CreateBonusPage';

export default CreateBonusPage;
